<template>
  <div class="barContent">
    <div id="mapChartBar1" style="width: 45%;height:28vh;"></div>
    <div id="mapChartBar2" style="width: 45%;height:28vh;"></div>
  </div>
</template>

<script>
import {getWarningNumber} from '../api/home'
export default {
  name: "bar",
  data() {
    return {
      myChart1: null,
      myChart2: null,
      option1: {
        title: {
          text: '',
          textStyle: {
            color: '#FFE680',
            fontSize: 30
          },
          subtext: '已处理',
          subtextStyle: {
            color: '#fff',
            fontSize: 16
          },
          itemGap: -5,
          left: 'center',
          top: 'center'
        },
        tooltip: {
          formatter: function (params) {
            return '<span style="color: #fff;">已处理：' + params.value + '条</span>';
          }
        },
        angleAxis: {
          max: 100,
          clockwise: true, // 逆时针
          // 隐藏刻度线
          show: false
        },
        radiusAxis: {
          type: 'category',
          show: true,
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,

          },
          axisTick: {
            show: false
          },
        },
        polar: {
          center: ['50%', '50%'],
          radius: '125%' //图形大小
        },
        series: [{
          type: 'bar',
          data: [8],
          showBackground: true,
          backgroundStyle: {
            color: '#373642',
            opacity: 1
          },
          coordinateSystem: 'polar',
          roundCap: true,
          barWidth:18,
          itemStyle: {
            normal: {
              color: '#FFE680',
            }
          },
        }]
      },
      option2: {
        title: {
          text: '',
          textStyle: {
            color: '#FF6D69',
            fontSize: 30
          },
          subtext: '未处理',
          subtextStyle: {
            color: '#fff',
            fontSize: 16
          },
          itemGap: -5,
          left: 'center',
          top: 'center'
        },
        tooltip: {
          formatter: function (params) {
            return '<span style="color: #fff;">未处理：' +  params.value + '条</span>';
          }
        },
        angleAxis: {
          max: 100,
          clockwise: true, // 逆时针
          // 隐藏刻度线
          show: false
        },
        radiusAxis: {
          type: 'category',
          show: true,
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,

          },
          axisTick: {
            show: false
          },
        },
        polar: {
          center: ['50%', '50%'],
          radius: '125%' //图形大小
        },
        series: [{
          type: 'bar',
          data: [88],
          showBackground: true,
          backgroundStyle: {
            color: '#361E3B',
            opacity: 1
          },
          coordinateSystem: 'polar',
          roundCap: true,
          barWidth:18,
          itemStyle: {
            normal: {
              color: '#FF6D69',
            }
          },
        }]
      },
      respondData:{
        unPassAmount:'',
        passAmount:''
      },//存储接口的相应数据
      timer:null
    }
  },
  mounted(){
    this.getWarningNumber()
    this.timer = setInterval(() => {
      this.getWarningNumber()
    },2000)
  },
  destroyed() {
    clearInterval(this.timer) //清除定时器
    this.myChart1.dispose() //销毁echarts 实例
    this.myChart2.dispose() //销毁echarts 实例
  },
  methods: {
    init() {
      this.myChart1 = this.$echarts.init(document.getElementById('mapChartBar1'));
      this.myChart2 = this.$echarts.init(document.getElementById('mapChartBar2'));
      this.myChart1.setOption(this.option1);
      this.myChart2.setOption(this.option2);
    },
    // 获取处理条数
    getWarningNumber(){
      getWarningNumber({
        jsessionId:sessionStorage.token
      }).then(res => {
        if(res.data.code === 0){
          if(this.respondData.passAmount != res.data.data.passAmount || this.respondData.unPassAmount != res.data.data.unPassAmount){ //数据发生变化后才去重新绘制图标
            this.respondData.passAmount = res.data.data.passAmount
            this.respondData.unPassAmount = res.data.data.unPassAmount
            this.option1.title.text =  res.data.data.passAmount + '条'
            this.option2.title.text =  res.data.data.unPassAmount + '条'
            this.option1.series[0].data = [res.data.data.passAmount]
            this.option2.series[0].data = [res.data.data.unPassAmount]
            this.init()
          }
        }
      })
    },
    resizeChart() {
      this.myChart1.resize()
      this.myChart2.resize()
    }
  },
}
</script>

<style scoped>
.barContent{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>